export default __webpack_public_path__ + "static/media/bottom.fa7a6260.jpg";